var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9531 8.40063C16.2663 8.40063 16.5667 8.5244 16.7891 8.74498L16.7871 8.73998C17.0086 8.96179 17.1331 9.26247 17.1331 9.57598C17.1331 9.88948 17.0086 10.1902 16.7871 10.412L11.6961 15.505C11.4743 15.7265 11.1736 15.851 10.8601 15.851C10.5466 15.851 10.2459 15.7265 10.0241 15.505L7.34608 12.827C7.22861 12.719 7.13423 12.5883 7.06863 12.4428C7.00302 12.2974 6.96755 12.1401 6.96435 11.9806C6.96115 11.8211 6.99028 11.6625 7.05 11.5145C7.10972 11.3666 7.19878 11.2322 7.31181 11.1196C7.42485 11.0069 7.55952 10.9184 7.70771 10.8592C7.85591 10.8 8.01455 10.7714 8.17407 10.7752C8.3336 10.779 8.49071 10.815 8.63594 10.8811C8.78116 10.9473 8.9115 11.0421 9.01908 11.16L10.8611 13.001L15.1171 8.74498C15.3394 8.5244 15.6399 8.40063 15.9531 8.40063Z",
    fill: "var(--icon-primary-color)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "var(--icon-primary-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic_success.43b04252039ab1113c41013163670321.svg";
export { ForwardRef as ReactComponent };